import { render } from "./ReportBugModal.vue?vue&type=template&id=63d787ed"
import script from "./ReportBugModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ReportBugModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./ReportBugModal.vue?vue&type=style&index=0&id=63d787ed&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__